// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__HUsxu","spin":"Spinner_spin__Xyt0e","beige":"Spinner_beige__bKJxk","brown":"Spinner_brown__0jZiO"};